module.exports = __webpack_public_path__ + "static/play-store-icon-13b07b4247a21b10d5b0212981361ffa.png";